<template>
  <div v-if="currentDelivery">
    <div class="input-group d-print-none">
      <RouterLink :to="{ name: 'delivery', params: { id: currentDelivery.id } }" class="btn btn-outline-secondary">
        <font-awesome-icon :icon="['fas', 'chevron-left']" />
        {{ $t('action.back') }}
      </RouterLink>
      <button class="btn btn-primary" @click="print">
        <font-awesome-icon :icon="['fas', 'print']" />
        {{ $t('action.printEllipsis') }}
      </button>
    </div>
    <LabelsPrintComponent :items="currentDelivery.lines" />
  </div>
  <div v-else>
    <span>{{ $t('error.noData') }}</span>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { useDeliveriesStore } from '@/stores';
import LabelsPrintComponent from "@/components/labels/LabelsPrintComponent.vue";
import Delivery from '@/models/frontend/Delivery';

const print = () => {
  window.print();
};

const deliveriesStore = useDeliveriesStore();

const props = defineProps({
  deliveryId: { type: Number, required: true }
});

const currentDelivery = ref<Delivery | undefined>(deliveriesStore.getById(props.deliveryId));

onMounted(async () => {
  if (currentDelivery?.value == undefined) {
    await deliveriesStore.fetch(props.deliveryId);
    if (deliveriesStore.delivery) {
      currentDelivery.value = deliveriesStore.delivery;
    }
  }
});
</script>
